import { snakeCase, toUpper } from 'lodash-es'
import requireFiles from '../base'

let requireResult = Object.create(null)

requireFiles.keys().forEach(key => {
  if (/\.config(\/index)?(\.js|\.ts)$/.test(key)) {
    const regex = /\w*(?=\.config)/
    const name: string = key.match(regex)?.[0] || ''
    requireResult = Object.assign(requireResult, {
      [toUpper(snakeCase(name))]: Object.freeze(requireFiles(key).default || requireFiles(key)),
    })
  }
})

export default Object.freeze(<any>requireResult)
